import React from 'react';
import { t } from '@lingui/core/macro';
import { UncontrolledTooltip } from 'src/components/ui';
import Icon from 'src/components/Icon';

/** Info icon beside a label; shows `text` on hover or keyboard focus. Line breaks in `text` are kept. */
export function InfoTip({ id, text }: { id: string; text: string }) {
  return (
    <>
      <button
        type="button"
        id={id}
        aria-label={t`More information`}
        aria-describedby={`${id}-text`}
        className="inline-flex items-center justify-center align-middle p-0 ml-1 border-0 bg-transparent cursor-help! theme-text-primary opacity-60 hover:opacity-100 focus-visible:opacity-100"
      >
        <Icon icon="Info" className="w-3.5 h-3.5" />
      </button>
      <span id={`${id}-text`} className="sr-only">
        {text}
      </span>
      <UncontrolledTooltip target={id} placement="top">
        <span className="block text-left whitespace-pre-line">{text}</span>
      </UncontrolledTooltip>
    </>
  );
}

export default InfoTip;
